import { aedService } from "../_services";
const getInitialState = () => {
  return {
    loading: false,
    step: 1,
    cancelStep: 1,
    owners: {},
    selectedOwner: undefined,
    selectedItems: [],
    newOwner: {
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      primaryPhone: "",
      isValid: false
    },
    currentOwnerItems: [],
    pendingFadderItems: [],
    pendingFadderSelectedItems: []
  };
};
const state = getInitialState();
export const owners = {
  namespaced: true,
  state: state,
  actions: {
    resendConfirmationEmail({ commit }, payload) {
      commit("setLoading");

      aedService.resendConfirmationEmail(payload).then(
        () => {
          commit("resendConfirmationEmailSuccess");
        },
        error => commit("alert/error", error, { root: true })
      );
    },
    getOwners({ commit }, payload) {
      commit("setLoading");

      aedService
        .getOwners(payload)
        .then(
          owners => commit("getOwnersSuccess", owners),
          error => commit("alert/error", error, { root: true })
        );
    },
    getCurrentOwnersItems({ commit }, payload) {
      commit("setLoading");
      aedService.getCurrentOwnersItems(payload).then(
        items => {
          commit("getCurrentOwnersItemsSuccess", items);
        },
        error => commit("alert/error", error, { root: true })
      );
    },
    getPendingFadderItems({ commit }, payload) {
      commit("setLoading");
      aedService.getPendingFadderItems(payload).then(
        items => {
          commit("getPendingFadderItemsSuccess", items);
        },
        error => commit("alert/error", error, { root: true })
      );
    },
    cancelMoveAEDs({ commit, dispatch }, { getAllpayload, aed, profileId }) {
      commit("setLoading");
      aedService
        .cancelMoveAEDs({ profileId, data: { aed, profile: profileId } })
        .then(
          () => {
            commit("nextCancelStep", 2);
            commit("submitOwnerChangeSuccess");
            dispatch("aed/getAll", getAllpayload, { root: true });
            return;
          },
          error => commit("alert/error", error, { root: true })
        );
    },
    createOrupdate(
      { commit, dispatch },
      { getAllpayload, aed, profile, newOwnerData, newOwner = false }
    ) {
      commit("setLoading");
      aedService
        .createOrupdate({
          data: newOwner ? newOwnerData : { aed, profile },
          newOwner
        })
        .then(
          newOwnerID => {
            if (!newOwnerID) {
              commit("nextStep", 3);
              commit("submitOwnerChangeSuccess");
              dispatch("aed/getAll", getAllpayload, { root: true });
              return;
            }
            commit("setSelectedOwner", newOwnerID);
            dispatch("createOrupdate", {
              getAllpayload,
              aed,
              profile: newOwnerID
            });
          },
          error => commit("alert/error", error, { root: true })
        );
    }
  },
  mutations: {
    setLoading(state) {
      state.loading = true;
    },
    resendConfirmationEmailSuccess(state) {
      state.loading = false;
    },
    getOwnersSuccess(state, owners) {
      state.owners = owners;
      state.loading = false;
    },
    getCurrentOwnersItemsSuccess(state, items) {
      state.currentOwnerItems = items;
      state.loading = false;
    },
    getPendingFadderItemsSuccess(state, items) {
      state.pendingFadderItems = items;
      state.loading = false;
    },
    setSelectedOwner(state, payload) {
      state.selectedOwner = payload;
    },
    setNewUserValidity(state, payload) {
      state.newOwner.isValid = payload;
    },
    nextStep(state, payload = ++state.step) {
      state.step = !payload ? ++state.step : payload;
    },
    nextCancelStep(state, payload = ++state.cancelStep) {
      state.cancelStep = !payload ? ++state.cancelStep : payload;
    },
    removePendingFadderSelectedItems(state, id) {
      state.pendingFadderSelectedItems = state.pendingFadderSelectedItems.filter(
        item => item !== id
      );
    },
    removeSelectedItem(state, id) {
      state.selectedItems = state.selectedItems.filter(item => item !== id);
    },
    addPendingFadderSelectedItems(state, id) {
      state.pendingFadderSelectedItems.push(id);
    },
    addSelectedItem(state, id) {
      state.selectedItems.push(id);
    },
    submitOwnerChangeSuccess(state) {
      state.loading = false;
    },
    resetNewOwner(state) {
      state.newOwner = getInitialState().newOwner;
    },
    resetState(state) {
      const initialState = getInitialState();
      state.step = initialState.step;
      state.cancelStep = initialState.cancelStep;
      state.owners = initialState.owners;
      state.selectedOwner = initialState.selectedOwner;
      state.selectedItems = initialState.selectedItems;
      state.pendingFadderItems = initialState.pendingFadderItems;
      state.pendingFadderSelectedItems =
        initialState.pendingFadderSelectedItems;
      Object.assign(state.newOwner, getInitialState().newOwner);
    }
  }
};
